import { render, staticRenderFns } from "./UrlRedirect.vue?vue&type=template&id=b4980a54&scoped=true"
import script from "./UrlRedirect.vue?vue&type=script&lang=js"
export * from "./UrlRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4980a54",
  null
  
)

export default component.exports